import { useSidebar } from "@/components/layouts/SidebarContext";
import { getCurrentBuildCode } from "@/utils/versioning";
import { useTranslation } from "react-i18next";
export const HubVersionMarker = () => {
  const {
    t
  } = useTranslation("meta");
  const {
    isSidebarCollapsed
  } = useSidebar();
  return <div className="transition-opacity" data-sentry-component="HubVersionMarker" data-sentry-source-file="HubVersionMarker.tsx">
      <div className={`flex h-6 w-full items-center justify-center whitespace-nowrap bg-gray-100 text-center text-xs text-gray-500 transition-opacity ${isSidebarCollapsed ? "opacity-0" : ""}`}>
        {t("buildNumber", {
        build: getCurrentBuildCode()
      })}
      </div>
    </div>;
};